import { createContext } from 'react'
export const ChatContext = createContext()
export const ChatProvider = ChatContext.Provider
